import type { HelplineId, LegalTopicId } from './types'

// Which official pages each answer is written from, and what the person can do
// next. Every URL and number here was checked on the official page on 29 Sep 2026.
// Re-check helpline numbers and fees before changing any answer text.

export interface LegalTopic {
  id: LegalTopicId
  icon: string
  /** English search words, so "FIR", "UPI" or "RTI" typed in any language finds the topic. */
  keywords: string
  sources: string[]
  actions: { label: string; href: string }[]
}

export const HELPLINES: { id: HelplineId; number: string }[] = [
  { id: 'emergency', number: '112' },
  { id: 'legal_aid', number: '15100' },
  { id: 'cyber', number: '1930' },
  { id: 'women', number: '181' },
  { id: 'consumer', number: '1915' }
]

export const LEGAL_TOPICS: LegalTopic[] = [
  {
    id: 'get_free_aid',
    icon: '🧑‍⚖️',
    keywords: 'free lawyer legal aid apply nalsa dlsa 15100 vakil',
    sources: ['https://nalsa.gov.in/faqs/', 'https://nalsa.gov.in/legal-aid/'],
    actions: [
      { label: '15100', href: 'tel:15100' },
      { label: 'Apply online (NALSA)', href: 'https://scourtapp.nic.in/lsams/nologin/applicationFiling.action?requestLocale=en' }
    ]
  },
  {
    id: 'who_free_aid',
    icon: '🤝',
    keywords: 'free lawyer eligible section 12 women children sc st disability income',
    sources: ['https://nalsa.gov.in/faqs/'],
    actions: [{ label: '15100', href: 'tel:15100' }]
  },
  {
    id: 'fir',
    icon: '🚓',
    keywords: 'fir police complaint zero fir superintendent magistrate bnss',
    sources: ['https://www.indiacode.nic.in/bitstream/123456789/21544/1/the_bharatiya_nagarik_suraksha_sanhita,_2023.pdf'],
    actions: [{ label: '112', href: 'tel:112' }]
  },
  {
    id: 'cyber_fraud',
    icon: '📱',
    keywords: 'online upi fraud cyber crime scam money bank otp 1930',
    sources: ['https://www.pib.gov.in/PressReleasePage.aspx?PRID=2085609', 'https://cybercrime.gov.in/'],
    actions: [
      { label: '1930', href: 'tel:1930' },
      { label: 'cybercrime.gov.in', href: 'https://cybercrime.gov.in/' }
    ]
  },
  {
    id: 'women',
    icon: '🛡️',
    keywords: 'woman women violence harassment domestic 181 112 ncw',
    sources: [
      'https://www.wcd.gov.in/offerings/women--helpline--scheme',
      'https://www.ncw.gov.in/contact-us/',
      'https://www.mha.gov.in/en/commoncontent/emergency-response-support-system-erss'
    ],
    actions: [
      { label: '181', href: 'tel:181' },
      { label: '112', href: 'tel:112' },
      { label: 'NCW complaint', href: 'https://ncwapps.nic.in/onlinecomplaintsv2/frmPubRegistration.aspx' }
    ]
  },
  {
    id: 'consumer',
    icon: '🛒',
    keywords: 'consumer complaint shop company product service refund 1915 edaakhil',
    sources: ['https://consumerhelpline.gov.in/', 'https://www.pib.gov.in/PressReleaseIframePage.aspx?PRID=2077857'],
    actions: [
      { label: '1915', href: 'tel:1915' },
      { label: 'consumerhelpline.gov.in', href: 'https://consumerhelpline.gov.in/' }
    ]
  },
  {
    id: 'summons',
    icon: '📜',
    keywords: 'court summons notice hearing date lawyer',
    sources: ['https://nalsa.gov.in/legal-aid/', 'https://ecourts.gov.in/ecourts_home/'],
    actions: [{ label: '15100', href: 'tel:15100' }]
  },
  {
    id: 'case_status',
    icon: '🔎',
    keywords: 'court case status cnr ecourts hearing next date',
    sources: ['https://ecourts.gov.in/ecourts_home/', 'https://services.ecourts.gov.in/ecourtindia_v6/'],
    actions: [{ label: 'services.ecourts.gov.in', href: 'https://services.ecourts.gov.in/ecourtindia_v6/' }]
  },
  {
    id: 'lok_adalat',
    icon: '🤲',
    keywords: 'lok adalat settlement compromise court fee',
    sources: ['https://nalsa.gov.in/lok-adalats/'],
    actions: []
  },
  {
    id: 'rti',
    icon: '📨',
    keywords: 'rti right to information application fee appeal',
    sources: ['https://rtionline.gov.in/faq.php', 'https://cic.gov.in/sites/default/files/RTI/RTIRules2012.pdf', 'https://cic.gov.in/sites/default/files/RTI-Act_English.pdf'],
    actions: [{ label: 'rtionline.gov.in', href: 'https://rtionline.gov.in/' }]
  },
  {
    id: 'grievance',
    icon: '🏛️',
    keywords: 'government office complaint grievance cpgrams pgportal',
    sources: ['https://pgportal.gov.in/', 'https://www.pib.gov.in/PressReleasePage.aspx?PRID=2226247'],
    actions: [{ label: 'pgportal.gov.in', href: 'https://pgportal.gov.in/' }]
  }
]
